const routes = [  
    {
      path: '/admin',
      name: 'admin',
      component: () => import(/* webpackChunkName: "empresa" */ '@/components/Home.vue'),
      meta: { public: false, app:true } 
    },
    {
      path: '/admin/listvacantes',
      name: 'listvacantes',
      component: () => import(/* webpackChunkName: "empresa" */ '@/components/Aplicacion/ListVacantes.vue'),
      meta: { public: false, app:true } 
    },
    {
      path: '/admin/dashboard',
      name: 'dashboard',
      component: () => import(/* webpackChunkName: "empresa" */ '@/components/Aplicacion/Dashboard.vue'),
      meta: { public: false, app:true } 
    },
    {
      path: '/admin/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "empresa" */ '@/components/Auth/login.vue'),
      meta: { public: true, app:false, onlyLoggedOut: true }
    },
    {
      path: '/admin/recuperarcuenta',
      name: 'recuperarcuenta',
      component: () => import(/* webpackChunkName: "empresa" */ '@/components/Auth/RecuperarCuenta.vue'),
      meta: { public: true, app:false, onlyLoggedOut: true }
    },
    {
      path: '/admin/reiniciarclave',
      name: 'reiniciarclave',
      component: () => import(/* webpackChunkName: "empresa" */ '@/components/Auth/ReiniciarClave.vue'),
      meta: { public: true, app:false, onlyLoggedOut: true }
    },
    {
      path: '/',
      name: 'visualizarvacantes',
      component: () => import(/* webpackChunkName: "empresa" */ '@/components/Aplicacion/VisualizacionVacantes.vue'),
      meta: { public: true, app:false } 
    },
  ];
  
  export default routes.map(route => {
    return { ...route }
  })